import { gql } from '@apollo/client';

export const DELETE_FILE = gql`
  mutation deleteFile($id: ID!) {
    file: deleteFileById(id: $id) {
      id
      name
    }
  }
`;
